module.exports = __webpack_public_path__ + "img/twitter.293ae33e.svg";